import React, { useMemo, useState } from "react";

import { connect } from "react-redux";

import { useHistory, useRouteMatch } from "react-router-dom";

import clsx from "clsx";
import {
  Chip,
  IconButton,
  makeStyles,
  TableCell,
  TableRow,
} from "@material-ui/core";

import CallSplitIcon from "@material-ui/icons/CallSplit";
import UpdateIcon from "@material-ui/icons/Update";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import CloseIcon from "@material-ui/icons/Close";

import DateComponent from "../../../components/DateComponent";
import ConfirmDialog from "../../../components/ConfirmDialog";
import LoadingComponent from "../../../components/LoadingComponent";

import TransactionDialog from "./TransactionDialog";

import ApiService from "../../../services/api";

import { formatPrice } from "../../../util";

const useStyles = makeStyles((theme) => ({
  name: {
    fontSize: "small",
    display: "flex",
    alignItems: "center",
  },
  pending: {
    fontStyle: "italic",
  },
  secondaryText: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    paddingRight: 5,
  },
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  venmoChip: {
    fontWeight: "bold",
    color: "white",
    backgroundColor: "#3396cd",
  },
  splitwiseChip: {
    fontWeight: "bold",
    color: "#52595F",
    backgroundColor: "#ACE4D6",
    textDecoration: "underline",
    cursor: "pointer",
  },
}));

const TransactionRow = ({ user, transaction, selected, splitwiseToken }) => {
  const classes = useStyles();
  const { splitwiseExpense, reconcileRecord } = transaction;

  const [dialogOpen, setDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const secondaryText = useMemo(
    () => (
      <div className={classes.secondaryText}>
        {reconcileRecord &&
        (reconcileRecord.recurring || // old format
          (reconcileRecord.options && reconcileRecord.options.recurring)) && ( // new format
            <UpdateIcon className={classes.icon} />
          )}
        {splitwiseExpense && (
          <Chip
            size="small"
            className={classes.splitwiseChip}
            label="Sent to Splitwise"
            component="a"
            href={
              "https://secure.splitwise.com/expenses/" + splitwiseExpense.id
            }
            target="_new"
          />
        )}

        {reconcileRecord && reconcileRecord.sentToVenmo && (
          <Chip
            size="small"
            className={classes.venmoChip}
            label="Sent to Venmo"
          />
        )}
      </div>
    ),
    [splitwiseExpense, transaction, classes]
  );
  /*
            <a
            href={
              "https://secure.splitwise.com/expenses/" + splitwiseExpense.id
            }
            target="_new"
            className={classes.splitwiseLink}
          >
            {`split with ${splitwiseExpense.users
              .map((u) => u.user.first_name)
              .join(", ")}`}
          </a>*/

  const history = useHistory();
  const { url } = useRouteMatch();

  const actionTaken = useMemo(
    () => splitwiseExpense || (reconcileRecord && reconcileRecord.sentToVenmo)
  );

  const handleClick = () => setDialogOpen(true);
  //history.push(`${url}/${transaction.transaction_id}`);

  const handleCloseDialog = () => setDialogOpen(false);

  const handleDelete = async (event) => {
    setLoading(true);
    try {
      if (splitwiseExpense) {
        await ApiService.initDeleteSplitwiseExpense({
          expense: splitwiseExpense,
          transaction_id: transaction.transaction_id,
          splitwiseToken,
        });
      } else {
        debugger;
        await ApiService.markSentToVenmo(user.uid, transaction, true);
      }
      setDeleteDialogOpen(false);
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
      setDeleteDialogOpen(false);
    }
  };
  return (
    <>
      <TableRow
        hover
        role="checkbox"
        aria-checked={selected}
        tabIndex={-1}
        selected={selected}
      >
        <TableCell align="center">
          <DateComponent dateString={transaction.date} />
        </TableCell>
        <TableCell component="th" scope="row">
          <div
            className={clsx(
              classes.name,
              transaction.pending ? classes.pending : null
            )}
          >
            {transaction.pending && (
              <HourglassEmptyIcon className={classes.icon} fontSize="small" />
            )}
            {transaction.name}
          </div>
          {secondaryText}
        </TableCell>
        <TableCell align="right">{formatPrice(transaction.amount)}</TableCell>
        <TableCell align="right">
          {!loading &&
            (!actionTaken ? (
              <IconButton
                disabled={transaction.amount < 0}
                onClick={handleClick}
              >
                <CallSplitIcon />
              </IconButton>
            ) : (
              <>
                <IconButton
                  onClick={
                    splitwiseExpense
                      ? () => setDeleteDialogOpen(true)
                      : handleDelete
                  }
                >
                  <CloseIcon />
                </IconButton>
                <ConfirmDialog
                  title="Delete Splitwise Expense"
                  content="Are you sure you want to delete this expense? This will completely remove this expense for ALL people involved, not just you."
                  action="delete"
                  open={deleteDialogOpen}
                  onCancel={() => setDeleteDialogOpen(false)}
                  onConfirm={handleDelete}
                />
              </>
            ))}
          {loading && (
            <LoadingComponent inner={true} noBackground={true} fill={true} />
          )}
        </TableCell>
      </TableRow>
      <TransactionDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        setLoading={setLoading}
        transaction={transaction}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.firebase.auth,
  splitwiseToken: state.firebase.profile.splitwiseToken,
});

export default connect(mapStateToProps)(TransactionRow);
